import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  open(event) {
    this.element.src = event.currentTarget.dataset.phoneCallUrl
  }
}
